import { Link } from "react-router-dom";
import { getByCategory, sortContent } from "@/lib/content";
import SectionHeader from "@/components/base/SectionHeader";

export default function MoviePicks() {
  const list = sortContent(getByCategory("movie-recommend"), "heat-desc").slice(
    0,
    6
  );

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <SectionHeader
          title="推荐电影精选"
          subtitle="按口碑与热度精选，帮你找到下一部好电影"
          moreTo="/category/movie-recommend"
          moreLabel="更多电影推荐"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {list.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group cursor-pointer"
            >
              <div className="rounded-xl overflow-hidden border border-background-200 mb-3">
                <div className="aspect-[3/4] w-full">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">
                {item.year} · {item.genre}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}